/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { Grid, capitalize } from "@mui/material";
import { AppContext } from "../../context/AppProvider";
import { CheckoutForm } from "./Form";
import { useNavigate } from "react-router-dom";

export const Checkout = (props) => {
  const { configuration, pricing, payment, createSubscription } = useContext(AppContext);
  const { email, promotion, pricePerMonth, pricePerUser, pricePerYear, pricePerVpnSeat } = configuration;
  const { discount } = pricing;
  const navigate = useNavigate();

  useEffect(() => {
    if (!payment.subscriptionId && !payment.secret && email) {
      createSubscription();
    }
  }, [email]);

  useEffect(() => {
    if (pricing?.user?.starter == 0) {
      navigate("/");
    }
  }, [pricing]);

  return (
    <Grid container>
      <Grid item md={6} className="form">
        <CheckoutForm />
      </Grid>

      <Grid item md={6} className="summary">
        <div className="summary-holder">
          <div className="summary-box">
            <div className="title">{capitalize(configuration.sku)} <span>Annual Payment</span> <div>${pricePerMonth}<span>/mo</span></div></div>
            <p>Kasm Workspaces Starter Subscription (Self-Supported)</p>
          </div>
          <div className="summary-table">
            <div className="line"><span>Price per user/month</span><span>${pricePerUser}</span></div>
            { configuration.vpnSeats > 0 && <div className="line"><span>PureVPN Egress per seat/month</span><span>${pricePerVpnSeat}</span></div>}
            <div className="line"><span>Total users</span><span>x{configuration.seats}</span></div>
            { configuration.vpnSeats > 0 && <div className="line"><span>Total PureVPN seats</span><span>x{configuration.vpnSeats}</span></div>}
            <div className="line"><span>Total per month</span><span>${pricePerMonth}</span></div>
            { promotion && discount && <div className="line"><span>Discount applied</span><span>{discount * 100}%</span></div>}
            <div className="line total"><span>Total <span className="sub">(billed annually)</span></span><span>${pricePerYear}</span></div>
          </div>
        </div>
      </Grid>
    </Grid>
  )
}